import React from 'react'
import Card from '@/components/ui/Card'
import CoachShoppingPanel from './CoachShoppingPanel'
import { useAuthContext } from '@/lib/auth-context'
import { useLockerProspect } from '@/hooks/useLockerProspect'

export default function LockerRoomShopping() {
  const { session, profile } = useAuthContext() as any
  const { prospect, loading, error, budget } = useLockerProspect()
  const isCoach = profile?.role === 'coach'

  return (
    <section className="space-y-4">
      <Card className="space-y-3">
        <div className="flex flex-wrap items-center justify-between gap-2">
          <div>
            <p className="text-xs uppercase tracking-wide text-stone-500">Locker room shopping</p>
            <h2 className="text-lg font-semibold text-stone-900">Shop with verified cards</h2>
            <p className="text-sm text-stone-600">
              Mirrors the teacher shopping flow so coaches can spend their locker room budget with the right prospect and
              locker room metadata attached to each session.
            </p>
          </div>
          <span className="rounded-full bg-stone-900/10 px-3 py-1 text-xs font-semibold uppercase text-stone-700">
            {isCoach ? 'Coach view' : 'Prospect view'}
          </span>
        </div>
        {budget.error ? <p className="text-sm text-brick">{budget.error}</p> : null}
      </Card>

      <CoachShoppingPanel prospect={prospect} session={session} isCoach={isCoach} loading={loading} error={error} />
    </section>
  )
}
